var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutodeskSvgGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 4.7 4.7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616F88",
    fillRule: "nonzero",
    d: "M2.86 0.12c-0.02,-0.02 -0.06,-0.12 -0.19,-0.12l-1.32 0c0,0 0.19,0.02 0.27,0.22 0,0 0.21,0.51 0.4,1 0.55,1.35 1.41,3.48 1.41,3.48l1.27 0c0.02,-0.02 -1.83,-4.56 -1.84,-4.58l0 0zm-1.74 0.18l-1.04 2.56c-0.06,0.18 -0.02,0.4 0.28,0.4l0.82 0 0.72 -1.8c-0.22,-0.59 -0.41,-1.07 -0.41,-1.07 -0.02,-0.05 -0.08,-0.21 -0.2,-0.21 -0.11,0 -0.15,0.1 -0.17,0.12l0 0zm-0.02 3.18l-0.87 0c-0.15,0 -0.23,-0.1 -0.23,-0.1 0.15,0.27 0.59,1.14 0.59,1.14 0.08,0.1 0.15,0.16 0.27,0.16 0.24,0 0.62,-0.25 0.62,-0.25l1.47 -0.95 -1.85 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodeskSvgGrey);
export default __webpack_public_path__ + "static/media/autodesk-svg-grey.9db26973e4b2f8f3c495e8cf76a2077c.svg";
export { ForwardRef as ReactComponent };